<template>
  <div class="container">
    <div class="field">
      <label class="label">Name</label>
      <div class="control">
        <input
          v-model.trim="simulation.label"
          class="input"
          type="text"
          placeholder="Simulation name"
          required
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Attacker</label>
    </div>
    <AttackFormField
      v-for="(attack, index) in simulation.attacks"
      :key="index"
      :attack="attack"
      :canRemoveAttack="canRemoveAttack"
    ></AttackFormField>
    <div class="field">
      <button class="button is-small" type="button" @click="addAttack">
        Add Attack
      </button>
    </div>
    <div class="field">
      <label class="label">Defender</label>
    </div>
    <div class="field is-horizontal">
      <DiceFormField :label="'DEF'" :dice="simulation.defense"></DiceFormField>
      <div class="field has-addons">
        <div class="control">
          <button class="button is-static">ARM</button>
        </div>
        <div class="control has-icons-left ">
          <input
            v-model.number="simulation.armor"
            required
            class="input"
            type="number"
            :max="10"
            min="1"
            step="1"
          />
          <span class="icon has-text-dark is-left"
            ><i class="fas fa-shield-alt"></i
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AttackFormField from "./AttackFormField";
import DiceFormField from "./DiceFormField";
export default {
  name: "SimulationForm",
  components: { DiceFormField, AttackFormField },
  props: {
    simulation: {
      type: Object,
      required: true
    }
  },
  computed: {
    canRemoveAttack() {
      return this.simulation.attacks.length > 1;
    }
  },
  methods: {
    addAttack() {
      this.$store.dispatch("addAttack");
    }
  }
};
</script>
